module.exports = __webpack_public_path__ + "sign-in-arrow.641c2884a1d84878c369b181e93a3286.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sign-in-arrow.svg
// module id = 78
// module chunks = 0